<template>
  <section id="contact" class="module">
    <div class="container">
      <div class="row">
        <div class="col-sm-11 col-sm-offset-1">
          <div class="col-xs-12">
            <h2>Contact Us</h2>
          </div>

          <div class="contact-text">
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <div class="col-xs-12 col-sm-3">
                  <span class="contact-label">E-mail:</span>
                </div>

                <div class="col-xs-12 col-sm-9 wrap">
                  <a :href="`mailto:${email}`">{{ email }}</a>
                </div>

                <div class="col-xs-12 col-sm-3">
                  <span class="contact-label">Phone: </span>
                </div>

                <div class="col-xs-12 col-sm-9">
                  {{ phone }}
                </div>
              </div>

              <div class="col-xs-12 col-sm-6">
                <div class="col-xs-12 col-sm-3">
                  <span class="contact-label">In-person:</span>
                </div>

                <div class="col-xs-12 col-sm-9" v-html="address"></div>
              </div>
            </div>
          </div>

          <div class="col-xs-12">
            <h2>Advertise in the best of issue</h2>
          </div>

          <div class="contact-text">
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <div class="col-xs-12 col-sm-3">
                  <span class="contact-label">E-mail:</span>
                </div>

                <div class="col-xs-12 col-sm-9 wrap">
                  <a href="mailto:snradinfo@newsreview.com?subject=Best%20of%20Sac%20Advertising%20Inquiry">snradinfo@newsreview.com</a>
                </div>
              </div>

              <div class="clearfix visible-sm-block"></div>

              <div class="col-xs-12 col-sm-6">
                <div class="col-xs-12 col-sm-3">
                  <span class="contact-label">Phone: </span>
                </div>

                <div class="col-xs-12 col-sm-9">
                  {{ phone }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      email: 'bestofsac@newsreview.com',
      phone: '916.498.1234',
      address: `1124 Del Paso Blvd,<br>Sacramento, CA 95815`
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_site_variables.scss';
  @import '@/assets/scss/partials/_mixins.scss';

  #contact {
    padding: 0px 0 50px;
    background: #000;

    .contact-text {
      font-size: $default-fontsize;
      color: $brand-tertiary;

      .contact-label {
        color: #fff;
      }
    }

    a {
      border-bottom: none;
      color: $brand-tertiary;

      &:hover {
        color: $brand-secondary;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue